/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/LeadPreview/Content/PersonDetails/Phone/Content"
  
}) {
let leadMetadataPersonPhonedetailsNumberValueData = fromData.useDataValue({ viewPath,
context: 'lead',
path: 'metadata.person.phoneDetails.number',
})
let constantData = ' ('
let leadMetadataPersonPhonedetailsTypeValueData = fromData.useDataValue({ viewPath,
context: 'lead',
path: 'metadata.person.phoneDetails.type',
})
let constantData1 = ')'
let aggregateData = fromHelpers.joinPhone(leadMetadataPersonPhonedetailsNumberValueData, constantData, leadMetadataPersonPhonedetailsTypeValueData, constantData1)
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceXxs}
 paddingBottom={dtSpaceXxs}
 data="lead.metadata.person.phoneDetails.number"
 data="' ('"
 data="lead.metadata.person.phoneDetails.type"
 data="')'"
 aggregate="helpers.js joinPhone"
 text={aggregateData}
/>
{children}
</React.Fragment>)
}